import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { UserProvider } from "@/contexts/UserContext";
import { NotificationProvider } from "@/components/NotificationSystem";
import Index from "./pages/Index";
import IndexFixed from "./pages/IndexFixed";
import Marketplace from "./pages/Marketplace";
import ServiceDetail from "./pages/ServiceDetail";
import ProductDetail from "./pages/ProductDetail";
import AppointmentCalendar from "./pages/AppointmentCalendar";
import JobDetail from "./pages/JobDetail";
import Profile from "./pages/Profile";
import AddProduct from "./pages/AddProduct";
import AddService from "./pages/AddService";
import Messages from "./pages/Messages";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <NotificationProvider>
          <TooltipProvider>
            <Toaster />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/beige" element={<IndexFixed />} />
                <Route path="/marketplace" element={<Marketplace />} />
                <Route path="/wom-plaza" element={<Marketplace />} />
                <Route path="/dienst-plaatsen" element={<AddService />} />
                <Route path="/add-service" element={<AddService />} />
                <Route path="/add-service/edit/:serviceId" element={<AddService />} />
                <Route path="/product-toevoegen" element={<AddProduct />} />
                <Route path="/add-product" element={<AddProduct />} />
                <Route path="/add-product/edit/:productId" element={<AddProduct />} />
                <Route path="/services" element={<Marketplace />} />
                <Route path="/service/:id" element={<ServiceDetail />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/book/:serviceId" element={<AppointmentCalendar />} />
                <Route path="/job/:id" element={<JobDetail />} />
                <Route path="/vacatures" element={<JobDetail />} />
                <Route path="/afspraken" element={<AppointmentCalendar />} />
                <Route path="/berichten" element={<Messages />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/profiel" element={<Profile />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </TooltipProvider>
        </NotificationProvider>
      </UserProvider>
    </QueryClientProvider>
  );
}

export default App;